import { createWebHistory, RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router';
import { i18n, loadLanguageAsync } from '@/locales/index';
import { routes } from 'vue-router/auto-routes';
import { createRouter } from 'vue-i18n-routing';
// import messages from '@intlify/unplugin-vue-i18n/messages';
import { messages } from '@/utils/language';

// import NProgress from 'nprogress';
import Cookies from 'js-cookie';
import { getLanguage, getLanguageSign } from '@/utils/language';
import { postSaveTraffic } from '@/api/member/register';
import devicePlatform from '@/utils/device';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { shareSourceMap } from '@/config/datadict';
import { useUserSotre } from '@/store/modules/user';
import { useRouteParams } from '@/store/modules/route-params';
import { getNoSignPath } from '@/utils/language';

type ScrollPositionNormalized = {
  behavior?: ScrollOptions['behavior'];
  left: number;
  top: number;
};
const whiteList = ['/fc26/fc26-boosting'];
// NProgress.configure({ showSpinner: false });
//使用 vue-i18n-routing 创建路由，约定式路由，自动导入
const router = createRouter(i18n, {
  history: createWebHistory(),
  routes: routes,
  strategy: 'prefix_and_default',
  defaultLocale: 'en',
  locales: messages,
  strict: true,
  scrollBehavior(_to: RouteLocationNormalized, _from: RouteLocationNormalized, savedPosition: ScrollPositionNormalized) {
    return new Promise(resolve => {
      setTimeout(() => {
        let scrollT = { left: 0, top: 0 };
        if (savedPosition) {
          scrollT = savedPosition;
        }
        resolve(scrollT);
      }, 400);
    });
  }
});
// const router = createRouter({
//   history: createWebHistory(),
//   routes: routes,
//   // 刷新时，滚动条位置还原
//   scrollBehavior(_to, _from, savedPosition) {
//     console.log(savedPosition);
//     if (savedPosition) {
//       return savedPosition;
//     } else {
//       return { top: 0 };
//     }
//   }
// });

router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) => {
  // 注册送优惠券，传参registerUrl为前页面路由
  const userStore = useUserSotre();
  const { updateRegisterUrl } = userStore;
  // const { state: state1 } = storeToRefs(userStore);
  updateRegisterUrl(getNoSignPath(from.fullPath).path || '/');
  // console.log('registerUrl', state1.value.registerUrl);
  // NProgress.start();
  if (whiteList.includes(to.path)) {
    const { state: routeState } = storeToRefs(useRouteParams());
    routeState.value.selectRoute = undefined;
  }
  const { isMobile, isTablet, isMobileOrTablet } = devicePlatform();
  if (to.meta.title) document.title = to.meta.title as string;
  const { state } = storeToRefs(useUserSotre());
  const path = decodeURIComponent(to.fullPath);
  // 动态加载语言包
  const locale = getLanguageSign(path) || getLanguage();
  await loadLanguageAsync(locale);
  // 设置多语言 标识
  document.documentElement.lang = locale;
  const lang = path.split('/');
  // 网红 推广链接 有效期7天
  const referralCode = to.query['referral-code'] as string;
  const invitationCode = to.query['invitationCode'] as string;
  let findSource: any[] = [];
  let channel = undefined;
  const routeQueryArr = Object.entries(to.query);
  if (referralCode) Cookies.set('referral-code', referralCode, { expires: 7 });
  if (invitationCode) Cookies.set('invitationCode', invitationCode, { expires: 1 });
  dayjs.extend(utc);
  dayjs.extend(timezone);
  if (!!routeQueryArr.length) {
    for (let i = 0; i < routeQueryArr.length; i++) {
      const find = shareSourceMap.find(self => self.code === routeQueryArr[0][0]);
      channel = find?.channel;
      findSource = routeQueryArr[i];
      if (!!channel) break;
    }
  }
  if (!!channel) {
    const data = {
      trafficSourceId: state.value.trafficSourceId || '',
      trafficSourceTraceBos: [
        {
          accessTime: dayjs.utc().tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss'),
          channel: channel ?? '自然搜索和直接访问',
          trafficSourceCode: findSource[1],
          route: to.path,
          device: !isMobileOrTablet ? 'PC' : isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Other'
        }
      ]
    };
    postSaveTraffic(data).then(res => {
      if (res.code === 200) {
        state.value.trafficSourceId = res.data.trafficSourceId || '';
      }
    });
  }
  if (path === to.fullPath) {
    if (lang[1] === 'en') {
      // 跳转到默认语言 去除en路径
      const newPath = path.replace('/en', '');
      next(newPath);
    } else {
      next(); // 继续正常的路由
    }
  } else {
    next();
  }
});
// router.afterEach(() => {
//   NProgress.done();
// });
export default router;
